import * as React from 'react';
import { ISearchResult } from '../../state-helpers/search-results';
import { IEpiProps } from '../../state-helpers/epi-props';
import { Lock } from './lock';
import { showPublishDate, showShortDescription } from './shared/results-helpers';
import { SearchResultLabels } from './shared/search-result-labels';

interface IProps {
    result: ISearchResult;
    epiProps: IEpiProps;

    onClick: () => void;
}

export class SearchResultShop extends React.Component<IProps, any> {

    placeholderImg(e) {
        e.target.src = '../../../Static/imgs/aap-img-placeholder.png';
    };

    onShopClick = () => {
        this.pushViewItemInListToGoogleAnalytics();
        this.props.onClick();
    }

    pushViewItemInListToGoogleAnalytics = () => {
        const { result } = this.props;
        var categories = "";
        if (result.categories && result.categories.length > 0) {
            categories = result.categories.join(" ");
        }

        (window as any).dataLayer = (window as any).dataLayer || [];
        (window as any).dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.

        var tag = {
            'event': 'select_item',
            'ecommerce':
            {
                'item_list_id': 'Search Page',
                'item_list_name': 'Search Page',
                'items': [
                    {
                        'item_id': result.itemNumber,
                        'item_name': result.title,
                        'price': result.itemRetailPrice,
                        'item_category': categories
                    }
                ]
            }
        };

        console.log(`Sending tag to data layer: ${JSON.stringify(tag)}`);
        (window as any).dataLayer.push(tag);
    }

    render() {
        const { result, onClick } = this.props;

        const divClass = 'search-result-wrapper' + (result.isBestBet ? ' search-result-wrapper-best-bet' : '');
        var categories = "";
        if (result.categories && result.categories.length > 0) {
            categories = result.categories.join(" ");
        }
        return (
            <div className={divClass} data-shop-search-result
                data-product-carousel-item-title={result.title}
                data-product-carousel-item-id={result.itemNumber}
                data-product-carousel-item-price={result.itemRetailPrice}
                data-product-carousel-item-category={categories}>
                <a className="search-result search-result-shop" href={result.url} onClick={this.onShopClick}>
                    <div className="search-result-header">
                        <div className="search-result-title" dangerouslySetInnerHTML={{ __html: result.title }} />
                        <div className="search-result-icon">
                            <svg className="shop-cart">
                                <use xlinkHref="#icon-cart"></use>
                            </svg>
                        </div>
                    </div>

                    <div className="search-result-shop">

                        <div className="search-result-shop-info">
                            {(showPublishDate(result) || showShortDescription(result)) &&
                                <div className="search-result-excerpt">
                                {showPublishDate(result) &&
                                        <span>
                                            <span className="search-result-excerpt-date">{result.publishDate.toString()}</span>
                                    {showShortDescription(result) &&
                                                <span className="middle-dot">&middot;</span>
                                            }
                                        </span>
                                    }
                                {showShortDescription(result) &&
                                    <span className="search-result-content" dangerouslySetInnerHTML={{ __html: result.shortDescription }}></span>
                                }
                                </div>
                            }

                            {(!!result.itemRetailPrice || !!result.itemMemberPrice) &&
                                <div className="search-result-meta">
                                    {result.itemRetailPrice != null &&
                                        <span className="search-result-meta-price">Retail Price: <span className="search-result-meta-price-value">${parseFloat(result.itemRetailPrice).toFixed(2)}</span></span>
                                    }
                                    {(result.itemRetailPrice != null) && (result.itemMemberPrice != null)
                                        && <span className="middle-dot">&middot;</span>
                                    }
                                    {result.itemMemberPrice != null &&
                                        <span className="search-result-meta-price">Member Price: <span className="search-result-meta-price-value">${parseFloat(result.itemMemberPrice).toFixed(2)}</span></span>
                                    }
                                </div>
                            }

                            <SearchResultLabels
                                result={result}
                                epiProps={this.props.epiProps}
                            />
                            <div className="search-result-product-info">
                                {/*Product type 4 is Online Course*/}
                                <p className="search-result-product-code"><b>{result.productType === 4 ? 'Course Id:' : 'Product Number:'}</b> {result.productCode}</p>
                            </div>
                        </div>

                        <div className="search-result-shop-img">
                            <img onError={this.placeholderImg.bind(this)} src={result.imageUrl} />
                        </div>
                    </div>
                    <div className="search-result-link">
                        <Lock url={result.url} />
                        <u>
                            {result.friendlyUrl}
                        </u>
                    </div>
                </a>
            </div>
        )
    }
}